import Lottie from "lottie-react";
import loaderAnimiation from "../../data/loader.json";

const Loader = () => {
  return (
    <Lottie
      animationData={loaderAnimiation}
      loop={true}
      style={{ width: "50%", height: "50%" }}
    />
  );
};

export default Loader;
